// extracted by mini-css-extract-plugin
module.exports = {"columnsWrapper":"FeedPostPage__columnsWrapper__HsYOY","column":"FeedPostPage__column__5d022"};